import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { numberWithDecimals } from "../../utils/validate";
const styles = StyleSheet.create({
  page: {
    padding: "50px 40px",
    fontSize: 8.5,
  },
  seccion: {
    marginBottom: 3,
  },
  title: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
    textAlign: "center",
    fontWeight: "bold",
    padding: 4,
    fontSize: 10,
  },
  text: {
    textAlign: "left",
    paddingLeft: 2,
  },
  text1: {
    fontWeight: "bold",
    textAlign: "right",
  },
  contenedorPadre: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: 1,
    borderTop: 1,
    borderRight: 1,
    borderLeft: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
  },
  contenedor: {
    textAlign: "center",
    justifyContent: "center",
    width: "100%",
    height: 20,
    borderLeft: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
  },
  contendor1: {
    flexDirection: "column",
    flex: 3,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
    paddingHorizontal: 8,
    paddingVertical: 2,
    gap: 5,
  },
  contendor2: {
    flexDirection: "column",
    flex: 1,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
    paddingHorizontal: 8,
    paddingVertical: 2,
    gap: 5,
  },
  contenedorTabla: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderStyle: "solid",
    borderColor: "#9e9e9e",
  },
  footer: {
    position: "absolute",
    bottom: 60,
    left: 0,
    right: 0,
    padding: 40,
  },
});
export const MyDocClearanceForm = ({ data }) => {
  return (
    <>
      <View style={{ ...styles.seccion }}>
        <View style={styles.title}>
          <Text>PLANILLA DE DESPACHO ADUANA NRO. {data.numero || ""}</Text>
        </View>
      </View>
      <View style={{ ...styles.seccion }}>
        <View style={{ ...styles.contenedorPadre }}>
          <View style={{ ...styles.contenedor, borderLeft: 0 }}>
            <Text>Fecha de Pago DIM</Text>
          </View>
          <View style={{ ...styles.contenedor }}>
            <Text style={{ ...styles.text }}>{data.fecha.dim}</Text>
          </View>
          <View style={{ ...styles.contenedor }}>
            <Text>Fecha de Planilla</Text>
          </View>
          <View style={{ ...styles.contenedor }}>
            <Text style={{ ...styles.text }}>{data.fecha.planilla}</Text>
          </View>
          <View style={{ ...styles.contenedor }}>
            <Text>N° Hoja de Trabajo</Text>
          </View>
          <View style={{ ...styles.contenedor }}>
            <Text style={{ ...styles.text }}>{data.cliente.hojaTrabajo}</Text>
          </View>
        </View>
      </View>
      <View style={{ ...styles.seccion }}>
        <View style={{ borderRight: 1, ...styles.contenedorPadre }}>
          <View style={{ ...styles.contendor1, paddingVertical: 8 }}>
            <Text style={{ fontWeight: "bold" }}>CLIENTE</Text>
            <Text>{data.cliente.nombre.toUpperCase()}</Text>
            <Text>{data.cliente.direccion.toUpperCase()}</Text>
            <Text>{data.cliente.email.toUpperCase()}</Text>
          </View>
          <View
            style={{
              borderLeft: 1,
              ...styles.contendor1,
              paddingVertical: 8,
            }}
          >
            <Text style={{ fontWeight: "bold" }}>DATOS DE DECLARACIÓN</Text>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 3 }}>N° De registro DIM:</Text>
              <Text style={{ flex: 5 }}>{data.declaracion.nroRegistro}</Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 3 }}>Regimn Aduanero:</Text>
              <Text style={{ flex: 5 }}>
                {data.declaracion.regimenAduanero}
              </Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 3 }}>Aduana de Despacho:</Text>
              <Text style={{ flex: 5 }}>{data.declaracion.aduanaDespacho}</Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 3 }}>Vaor CIF:</Text>
              <Text style={{ flex: 5 }}>
                {numberWithDecimals(Number(data.declaracion.valoCif))}
              </Text>
            </View>
            <View style={{ flexDirection: "row" }}>
              <Text style={{ flex: 3 }}>Canal:</Text>
              <Text style={{ flex: 5 }}>{data.declaracion.canal}</Text>
            </View>
          </View>
        </View>
      </View>
      <View style={{ ...styles.seccion, marginTop: 5 }}>
        <View style={{ paddingHorizontal: 8, gap: 5 }}>
          <Text style={{ fontWeight: "bold" }}>
            DESCRIPCIÒN DE LA MERCADERIA:
          </Text>
          <Text>{data.descripcionMercadria}</Text>
        </View>
      </View>
      <View style={{ ...styles.seccion, marginTop: 5 }}>
        <View style={{ borderRight: 1, ...styles.contenedorPadre }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ fontWeight: "bold" }}>DESCRIPCIÒN DEL GASTO</Text>
          </View>
          <View style={{ borderLeft: 1, ...styles.contendor1, flex: 1 }}>
            <Text style={{ fontWeight: "bold", textAlign: "center" }}>
              IMPORTE Bs.
            </Text>
          </View>
        </View>
        <View style={{ ...styles.contenedorTabla, marginTop: 5 }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ fontWeight: "bold" }}>
              Tributos y Otros Conceptos Aduaneros
            </Text>
          </View>
          <View style={{ ...styles.contendor1, flex: 1 }}>
            <Text style={{ fontWeight: "bold" }}></Text>
          </View>
        </View>
        {data.tributos.map((item, index) => (
          <View key={index} style={{ ...styles.contenedorTabla }}>
            <View style={{ ...styles.contendor1, paddingLeft: 30 }}>
              <Text>{item.desc}</Text>
            </View>
            <View style={{ ...styles.contendor1, flex: 1 }}>
              <Text style={{ textAlign: "right" }}>
                {numberWithDecimals(Number(item.importe))}
              </Text>
            </View>
          </View>
        ))}
        <View style={{ ...styles.contenedorTabla, marginTop: 5 }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ fontWeight: "bold" }}>
              Erogaciones necesarias para el Despacho Aduanero
            </Text>
          </View>
          <View style={{ ...styles.contendor1, flex: 1 }}>
            <Text style={{ fontWeight: "bold" }}></Text>
          </View>
        </View>
        {data.erogaciones.map((item, index) => (
          <View key={index} style={{ ...styles.contenedorTabla }}>
            <View style={{ ...styles.contendor1, paddingLeft: 30 }}>
              <Text>{item.desc}</Text>
            </View>
            <View style={{ ...styles.contendor1, flex: 1 }}>
              <Text style={{ textAlign: "right" }}>
                {numberWithDecimals(Number(item.importe))}
              </Text>
            </View>
          </View>
        ))}
        <View style={{ ...styles.contenedorTabla, marginTop: 5 }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ fontWeight: "bold" }}>Honorarios Profesionales</Text>
          </View>
          <View style={{ ...styles.contendor1, flex: 1 }}>
            <Text style={{ fontWeight: "bold" }}></Text>
          </View>
        </View>
        {data.honorarios.map((item, index) => (
          <View key={index} style={{ ...styles.contenedorTabla }}>
            <View style={{ ...styles.contendor1, paddingLeft: 30 }}>
              <Text>{item.desc}</Text>
            </View>
            <View style={{ ...styles.contendor1, flex: 1 }}>
              <Text style={{ textAlign: "right" }}>
                {numberWithDecimals(Number(item.importe))}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View style={{ ...styles.seccion, marginTop: 10 }}>
        <View style={{ ...styles.contenedorTabla }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ ...styles.text1 }}>
              Total Tributos, Erogaciones del Despacho y Honorarios
              Profesionales:
            </Text>
          </View>
          <View style={{ borderLeft: 1, ...styles.contendor2 }}>
            <Text style={{ ...styles.text1 }}>
              {numberWithDecimals(Number(data.totalGeneral || 0))}
            </Text>
          </View>
        </View>
        <View style={{ ...styles.contenedorTabla }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ ...styles.text1 }}>
              Tributos pagados por el importador:
            </Text>
          </View>
          <View style={{ ...styles.contendor2 }}>
            <Text style={{ ...styles.text1 }}>
              {numberWithDecimals(Number(data.tributosImportador || 0))}
            </Text>
          </View>
        </View>
        <View style={{ ...styles.contenedorTabla }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ ...styles.text1 }}>Anticipo del importador:</Text>
          </View>
          <View style={{ ...styles.contendor2 }}>
            <Text style={{ ...styles.text1 }}>
              {numberWithDecimals(Number(data.anticipoImportador || 0))}
            </Text>
          </View>
        </View>
        <View style={{ ...styles.contenedorTabla }}>
          <View style={{ ...styles.contendor1 }}>
            <Text style={{ ...styles.text1 }}>Saldo Contable:</Text>
          </View>
          <View style={{ ...styles.contendor2 }}>
            <Text style={{ ...styles.text1 }}>
              {numberWithDecimals(Number(data.saldoContable || 0))}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.footer}>
        <View style={{ borderTop: 1, ...styles.contenedorTabla }}>
          <View style={{ ...styles.contendor1, flex: 9 }}>
            <Text style={{ textAlign: "justify" }}>
              Nota:{"\n"}
              {"\n"}
              Para su mayor comodidad, Ud. puede efectuar el depósito del monto
              señalado a favor de{" "}
              <Text style={{ fontWeight: "bold" }}>
                SCZPLUS AGENCIA DESPACHANTE DE ADUANA S.R.L.
              </Text>{" "}
              cuenta en Bs.
              <Text style={{ fontWeight: "bold" }}>
                Nº 1133009863 BANCO GANADERO
              </Text>{" "}
              haciendo referencia a la presente Planilla, si tiene alguna duda,
              por favor comuníquese con nosotros a través del correo
              contabilidad@g-scz.com
            </Text>
          </View>
          {/* <View
            style={{
              ...styles.contendor1,
              flex: 1,
              alignSelf: "center",
              minWidth: "50px",
            }}
          >
            <Text style={{ fontWeight: "bold", textAlign: "center" }}>
              Código QR
            </Text>
          </View> */}
        </View>
      </View>
    </>
  );
};
